import moment, { Moment } from 'moment'

import Vue from 'vue'
import VueMoment from 'vue-moment'

moment.updateLocale('pt-br', {
  calendar: {
    sameDay: '[Hoje]',
    nextDay: '[Amanhã]',
    nextWeek (this: Moment) {
      const prefix = this.isoWeekday() > 5 ? 'Próximo' : 'Próxima'
      return `[${prefix}] dddd`
    },
    lastDay: '[Ontem]',
    lastWeek: 'dddd',
    sameElse: 'DD/MM/YYYY'
  },
  relativeTime: {
    future: (str) => str === 'agora' ? str : `em ${str}`,
    past: (str) => str === 'agora' ? str : `há ${str}`,
    s: 'agora',
    m: '1 minuto',
    h: '1 hora',
    d: '1 dia',
    M: '1 mês',
    y: '1 ano'
  }
})

// Remove relative time thresholds.
moment.relativeTimeThreshold('s', 60)
moment.relativeTimeThreshold('ss', 59)
moment.relativeTimeThreshold('m', 60)
moment.relativeTimeThreshold('h', 24)

Vue.use(VueMoment, { moment })
